module.exports = __webpack_public_path__ + "img/result-y4.b03381da.png";